<template>
  <v-container fluid
  ><form action @submit.prevent="submitForm">
    <div class="error" v-if="error">
      <p>{{ error }}</p>
    </div>

    <div class="access-info">
      <p>{{ $t("app.grant-access.text-1") }}</p>
      <ul>
        <li>
          {{
            `${$t("app.grant-access.text-2a")} ${
              this.$store.getters.user.patient.firstName
            } ${$t("app.grant-access.text-2b")}`
          }}
        </li>
        <li>
          {{
            `${$t("app.grant-access.text-3a")} ${
              this.$store.getters.user.patient.firstName
            } ${$t("app.grant-access.text-3b")}`
          }}
        </li>
        <li>{{ $t("app.grant-access.text-4") }}</li>
      </ul>
      <p>{{ $t("app.grant-access.text-5") }}</p>
      <v-divider></v-divider>
    </div>

    <v-row no-gutters>
      <v-col>
        <InputField
          v-model="form.email"
          :labelTitle="$t('app.grant-access.form-email')"
          type="email"
          required
          :placeholder="$t('app.grant-access.form-email-placeholder')"
          margin="25px auto"
        ></InputField>
        <v-btn
          color="#00a9b3"
          style="color: white; width: 90%"
          type="submit">
          {{$t('app.grant-access.action-invite')}}
        </v-btn>
      </v-col>
    </v-row>
    <div class="divider"></div>
    <v-row justify="center" align="center" class="w-100">
      <v-col cols="12" md="8">
      <h2>{{ $t("dash.patient.invited") }}</h2>
      <v-list v-if="parentInvites" two-line class="v-list-view">
        <template v-for="(invite) in parentInvites">
          <v-divider :key="`div-${invite.id}`"></v-divider>
          <v-list-item :key="invite.id" class="align-content-start text-align-left">
            <v-list-item-content>
              <v-list-item-title class="align-content-start align-start">
                {{ invite.name }} <span v-if="invite.email">{{ invite.email }} </span>
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t("dash.patient.parent.invite-last-update") }} {{ invite.updatedAt | moment('D MMMM YYYY') }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text v-if="invite.accepted">
                <v-btn text disabled>{{ $t("dash.patient.parent.invite-accepted") }}</v-btn>
              </v-list-item-action-text>
              <template v-else>
                <v-list-item-action-text v-if="currentVisibleCode.id === invite.id && currentVisibleCode.code">
                  <v-text-field readonly :value="currentVisibleCode.code"></v-text-field>
                </v-list-item-action-text>
                <v-list-item-action-text v-else
                                         @click.prevent="requestCode(invite.id)">
                  <v-btn text>{{ $t("dash.patient.parent.invite-show-code") }}</v-btn>
                </v-list-item-action-text>
              </template>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
      </v-col>
    </v-row>
    </form
  ></v-container>
</template>

<script>
import {neoparentUsers, userInvites} from "@/api";
import moment from "moment";

export default {
  name: "neoparent-access",
  data() {
    return {
      currentVisibleCode: {
        id: null,
        code: null
      },
      success: "",
      error: "",
      form: {
        email: "",
        message: this.$t("app.grant-access.form-message-value")
      },
      loading: false,
      invites: []
    };
  },
  mounted() {
    this.getInvitesList()
  },
  computed: {
    moment() {
      return moment
    },
    parentInvites() {
      if (this.invites.length > 0) {
        const invites = this.invites;
        return invites.sort((a, b) => {
          return new Date(b.updatedAt) - new Date(a.updatedAt);
        });
      }
      return [];
    }
  },
  methods: {
    getInvitesList() {
      const that = this
      userInvites.getList().then((res) => {
        that.invites = res.data.invites
      })
    },
    requestCode(inviteId) {
      this.loading = true;
      userInvites
        .refreshParent(inviteId)
        .then(result => {
          // Keep the list timestamp in sync and reveal the refreshed code for this invite.
          const inviteNdx = this.invites.findIndex(invite => invite.id === inviteId)
          if (inviteNdx !== -1) {
            this.invites[inviteNdx].lastUpdate = result.data.lastUpdate;
          }
          this.currentVisibleCode = {
            id: inviteId,
            code: result.data.code
          }
        })
        .catch(err => {
          this.error = err.response.data.message;
          this.consoleLog(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitForm() {
      const that = this
      if (confirm(this.$t("app.grant-access.confirm"))) {
        this.loading = true;
        const data = {
          email: this.form.email,
          message: this.form.message,
          patientId: this.$store.getters.patient.id
        };

        neoparentUsers
          .grantAccessToOther(data)
          .then(result => {
            this.consoleLog("Email sent");
            this.consoleLog(result);
            this.success = this.$t("success.invite-sent-to", {email: data.email});
            window.scrollTo(0, 0);
            this.loading = false;
            that.form.email = ""
            that.getInvitesList()
          })
          .catch(err => {
            this.consoleLog(err);
            this.error = err.response.data.message;
            window.scrollTo(0, 0);
            this.loading = false;
          });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.divider {
  width: 100%;
  height: 1px;
  background-color: #e57378;
  margin: 16px 0;
}

.v-list-view {
  align-items: start !important;
  text-align: left !important;
}
</style>
